import { apiUrlPrefix } from "../../../config";


// This is retrieving all the reports from users to an admin level
const fetchSuspendedUsers = async (discussionId, communityId, setReports) => {
    try {

        if((communityId === undefined || communityId.length < 10) && (discussionId === undefined || discussionId.length < 10)) {
            return;
        }

        if (communityId === undefined) {
            communityId = '';
        } if (discussionId === undefined) {
            discussionId = '';
        }

        const response = await fetch(
            `${apiUrlPrefix}Report/getSuspendedUsers?discussionId=${discussionId}&communityId=${communityId}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        if (response.ok) {
            const data = await response.json();
            const flatData = Array.isArray(data) ? data.flat() : [];
            if (!data.includes("null")) {
                setReports(flatData);
            }
            return flatData; // Return the data so your component can use it
        } else {
            console.error("Failed to fetch discussions");
        }
    } catch (error) {
        console.error("Error fetching discussions:", error);
    }
};

export default fetchSuspendedUsers;